export default function PrivacyPage() {
  return (
    <div style={{ maxWidth: '800px', padding: '0 20px', margin: '150px auto' }}>
      <p>Privacy Policy</p>

      <p>This Privacy Policy was last updated on February 27, 2023.</p>

      <p>​</p>

      <p>
        This Privacy Policy explains how AUMHUM Private Limited. (&quot;AUMHUM&quot;, &quot;we&quot;
        or &quot;us&quot;) collects, uses, and discloses information about you when you access or
        use our websites, mobile application, and other online products and services (collectively,
        the &quot;Services&quot;), and when you contact our&nbsp;customer&nbsp;service team, engage
        with us on social media, or otherwise interact with us. This policy does not apply to
        subscription eligibility information we receive from and process on behalf of our enterprise
        business customers and partners (defined as &quot;Customer Data&quot; in the applicable
        agreement), but this Privacy Policy does apply to your use of the Services, regardless of
        your subscription or account type. Additional information for individuals in the EEA, UK,
        and Switzerland &nbsp;can be found at the end of this Privacy Policy.
      </p>

      <p>
        We may change this Privacy Policy from time to time. If we make changes, we will notify you
        by revising the date at the top of the policy and, in some cases, we may provide you with
        additional notice (such as adding a statement to our website homepage or sending you a
        notification). We encourage you to review the Privacy Policy whenever you access the
        Services or otherwise interact with us to stay informed about our information practices and
        the choices available to you.
      </p>

      <p>​</p>

      <h3>Collection of Information</h3>

      <p>Information You Provide to Us</p>

      <p>
        We collect information when you register for an account, participate in interactive features
        (like by submitting a meditation or a mentor rating or completing a daily check-in), fill
        out a form or a survey, participate in a contest or promotion, make a purchase, communicate
        with us via social media sites, request customer support, or otherwise communicate with us.
        The information you may provide includes your name, email, password, street address, payment
        method information, goals, previous meditation, wellness experience, moods and reflections
        you provide during check-ins, feedback and survey responses, and other information about you
        included within your messages to us or otherwise provided via the Services. Some users also
        provide health-related information in connection with providing feedback or other messages
        to us, and we process that information consistent with the purpose for which it was
        provided. Some users upload a profile picture from their device. With relevant permission
        from the user, AUMHUM accesses your device storage to allow the user to upload their
        picture, which is attached to user&#39;s own profile. Additionally, if the users intends to
        get his audio recording analyzed by an expert meditation mentor or chant analyst, the user
        can send their audio file to AUMHUm team either through a functionality in the app or to us
        through a relevant alternate medium directly such as email attachment. Such information is
        &nbsp;used for providing feedback to the user on their chanting of the mantra and
        enunciation.
      </p>

      <p>​</p>

      <p>​</p>

      <p>Other Information About Your Use of the&nbsp;Services</p>

      <p>When you use our Services, we collect the following information about you:</p>

      <ul>
        <li>
          <p>
            Usage Information: Whenever you use our Services, we collect usage information, such as
            the sessions you use, videos you view or content you listen to, what screens or features
            you access, and other similar types of usage information.
          </p>
        </li>
        <li>
          <p>
            Transactional Information: When you make a purchase or return, we collect information
            about the transaction, such as product description, price, subscription or free trial
            expiration date, and time and date of the transaction.
          </p>
        </li>
        <li>
          <p>
            Log Information: We collect standard log files when you use our Services, which include
            the type of web browser you use, app version, access times and dates, pages viewed, your
            IP address, and the page you visited before navigating to our websites.
          </p>
        </li>
        <li>
          <p>
            Device Information: We collect information about the computer or mobile device you use
            to access our Services, including the hardware model, operating system and version,
            device identifiers set by your device operating system, and mobile network information
            (like your connection type, carrier and region).
          </p>
        </li>
        <li>
          <p>
            Information we Record: On some occasions, we may record phone or video calls with your
            consent, such as in connection with our coaching program or when you provide us with
            feedback or market research.
          </p>
        </li>
        <li>
          <p>
            Information we Generate: We generate some information about you based on other
            information we have collected. For example, like most platforms, we use your IP address
            to derive the approximate location of your device. We also use your first name to make
            an educated guess about your gender and use information about your activity to help
            determine the likelihood of you continuing to use our Services in the future (which we
            hope will be the case!).
          </p>
        </li>
        <li>
          <p>
            Information Collected by Cookies and Similar Tracking Technologies: We use different
            technologies to collect information, including cookies and web beacons. Please see our
            Cookie Policy for more details:&nbsp;
            <a href="https://aumhum.com/cookies" rel="noreferrer" target="_blank">
              https://aumhum.com/cookies
            </a>
            &nbsp;
          </p>
        </li>
      </ul>

      <p>​</p>

      <p>Information We Collect from Other Sources</p>

      <p>
        We also obtain information about you from other sources, including transaction information
        from third-party app stores you use to install our app or purchase a subscription, and name
        and contact information from third-party calendar services. Additionally, if you create or
        log into your account through a social media service account, we will have access to certain
        information from that account, such as your name and other account information, in
        accordance with the authorization procedures set by that social media service. Finally, we
        may obtain information about you from publicly available sources, marketing and advertising
        partners, consumer research platforms, and/or business contact databases.
      </p>

      <p>​</p>

      <p>​</p>

      <h3>Use of Information</h3>

      <p>We use the information we collect to:</p>

      <ul>
        <li>
          <p>
            Provide, maintain and improve our Services, including debugging to identify and repair
            errors, and developing new products and services;
          </p>
        </li>
        <li>
          <p>Process transactions and fulfill orders;</p>
        </li>
        <li>
          <p>
            Send you transactional or relationship messages, such as receipts, account
            notifications, customer service responses, and other administrative messages;
          </p>
        </li>
        <li>
          <p>
            Communicate with you about products, services, and events offered by AUMHUM and others,
            request feedback, and send news, gifts or other information we think will be of interest
            to you (see the &quot;Your Choices&quot; section below for information on how to opt out
            of marketing messages);
          </p>
        </li>
        <li>
          <p>Monitor and analyze trends, usage, and activities in connection with our Services;</p>
        </li>
        <li>
          <p>
            Detect, investigate and prevent fraudulent transactions and other illegal activities and
            protect the rights and property of AUMHUM and others, including to enforce our
            agreements and policies. If you feel your transaction was declined in error, please
            contact us for assistance at&nbsp;
            <a href="mailto:namaste@aumhum.com">namaste@aumhum.com</a>;
          </p>
        </li>
        <li>
          <p>
            Comply with the law, such as by processing transactional records for tax filings and
            other compliance activities;
          </p>
        </li>
        <li>
          <p>
            Personalize your online experience and the advertisements you see on other platforms
            based on your preferences, interests, and browsing behavior; and
          </p>
        </li>
        <li>
          <p>
            Facilitate contests, sweepstakes, and promotions and process and deliver entries and
            rewards.
          </p>
        </li>
      </ul>

      <p>​</p>

      <h3>Sharing of Information</h3>

      <p>
        We share information about you as follows and as otherwise described in this Privacy Policy
        or at the time of collection:
      </p>

      <ul>
        <li>
          <p>
            With companies and contractors that perform services for us, including email service
            providers, payment processors, fraud prevention vendors and other service providers;
          </p>
        </li>
        <li>
          <p>
            In response to a request for information if we believe disclosure is in accordance with,
            or required by, any applicable law or legal process, including court order, subpoena, or
            other lawful requests by public authorities to meet national security or law enforcement
            requirements;
          </p>
        </li>
        <li>
          <p>
            If we believe your actions are inconsistent with our user agreements or policies, if we
            believe you have violated the law, or to protect the rights, property, and safety of
            Calm or others;
          </p>
        </li>
        <li>
          <p>
            In connection with, or during negotiations of, any merger, sale of company assets,
            financing or acquisition of all or a portion of our business by another company;
          </p>
        </li>
        <li>
          <p>
            Between and among AUMHUM and our current and future parents, affiliates, subsidiaries,
            and other companies under common control and ownership; and
          </p>
        </li>
        <li>
          <p>
            With your consent or at your direction. for instance, you may choose to share actions
            you take on our Services with third-party social media services via the integrated tools
            we provide via our Services.
          </p>
        </li>
      </ul>

      <p>
        We also share aggregated or other information not subject to obligations under the data
        protection laws of your jurisdiction with third parties. For example, we sometimes share
        aggregate information with research organizations to help facilitate their research.
      </p>

      <p>&nbsp;</p>

      <h3>Advertising and Analytics Services Provided by Others</h3>

      <p>
        We allow others to provide analytics services and serve advertisements on our behalf across
        the web and in mobile applications. These entities use cookies, web beacons, device
        identifiers and other technologies to collect information about your use of the Services and
        other websites and online services, including your IP address, device identifiers, web
        browser, mobile network information, pages viewed, time spent on pages or in apps, links
        clicked, and conversion information. This information may be used by AUMHUM and others to,
        among other things, analyze and track data, determine the popularity of certain content,
        deliver advertising and content targeted to your interests on our Services and other
        websites and online services, and better understand your online activity. You can disable
        cookies used for advertising purposes through our cookie preferences manager. Or, for more
        information about interest-based ads, including to use ad industry tools to opt out of
        having your web browsing information used for behavioral advertising purposes, please
        visit&nbsp;
        <a href="http://www.aboutads.info/choices" rel="noreferrer noopener" target="_blank">
          www.aboutads.info/choices
        </a>
        &nbsp;(if you are in the EU, please visit&nbsp;
        <a href="https://www.youronlinechoices.eu/" rel="noreferrer noopener" target="_blank">
          https://www.youronlinechoices.eu/
        </a>
        ). Your mobile device should also include a feature that allows you to opt out of having
        certain information collected through apps used for behavioral advertising purposes.
      </p>

      <h2>&nbsp;</h2>

      <h3>Data Transfer</h3>

      <p>
        AUMHUM is based in India and processes information in India and the United States, which may
        not provide equivalent levels of data protection as your home jurisdiction.
      </p>

      <p>​</p>

      <h3>Your Choices</h3>

      <p>Account Information</p>

      <p>
        You may update certain account information you provide to us (such as your password, name
        and email address) by logging into your account or contacting us through our Help Center
        at&nbsp;<a href="mailto:namaste@aumhum.com">namaste@aumhum.com</a>. If you wish to disable
        your account, please contact us at&nbsp;
        <a href="mailto:namste@aumhum.com">namste@aumhum.com</a>, but note that we retain certain
        information when required or permitted by law. We also retain cached or archived copies of
        information about you for a certain period of time.
      </p>

      <p>Promotional Communications</p>

      <p>
        You may opt out of receiving promotional emails from AUMHUM by following the instructions in
        those emails or by logging into your account. If you opt out, we may still send you
        non-promotional emails, such as those about your account or our ongoing business relations.
      </p>

      <p>Mobile Push Notifications/Alerts</p>

      <p>
        With your consent, we send promotional and other push notifications to your mobile device.
        You can deactivate these messages at any time by changing the notification settings on your
        mobile device.
      </p>

      <p>Data Access and Deletion</p>

      <p>
        Subject to certain limits and conditions provided under law, we honor the exercise of the
        right of access or deletion for all of our users, regardless of their location. Any AUMHUM
        user may exercise this right by contacting us at&nbsp;
        <a href="mailto:namaste@aumhum.com">namaste@aumhum.com</a>
      </p>

      <p>&nbsp;</p>

      <h3>Information for Individuals in Switzerland, UK and the EEA</h3>

      <p>
        The sections below apply to you if you use our Services while in Switzerland, the United
        Kingdom or the European Economic Area (collectively, &quot;Europe&quot;). AUMHUM PRIVATE
        LIMITED. is the data controller for personal data governed by this Privacy Policy.
      </p>

      <p>Legal Basis for Processing</p>

      <p>When we process your personal data we will only do so in the following situations:</p>

      <ul>
        <li>
          <p>
            As necessary to perform our responsibilities under our contract with you (like
            processing payments and providing the products or services you have requested);
          </p>
        </li>
        <li>
          <p>
            When we have a legitimate interest in processing your personal data, including to
            communicate with you about changes to our Services, to help secure and improve our
            Services (including to prevent fraud) and to analyze use of our Services;
          </p>
        </li>
        <li>
          <p>As necessary to comply with our legal obligations; and</p>
        </li>
        <li>
          <p>When we have your consent to do so.</p>
        </li>
      </ul>

      <p>Data Retention</p>

      <p>
        We retain personal data for no longer than is necessary for the purposes for which it is
        processed, unless applicable law requires storage for a longer period of time.
      </p>

      <p>Data Subject Requests</p>

      <p>
        Subject to certain limits and conditions provided under law, you have the following rights:
      </p>

      <ul>
        <li>
          <p>
            You have the right to access personal data we hold about you and to ask that your
            personal data be corrected, erased, or made available in a portable form.
          </p>
        </li>
        <li>
          <p>
            You also have the right to object to certain processing (like receiving direct
            marketing), or request that we restrict processing in certain circumstances (like to
            retain but not further process pending resolution of a claim).
          </p>
        </li>
        <li>
          <p>When we ask for your consent, you may withdraw that consent at any time.</p>
        </li>
        <li>
          <p>
            You have the right to file a complaint regarding our data protection practices with a
            supervisory authority. Please see this directory for contact details:&nbsp;
            <a
              href="https://edpb.europa.eu/about-edpb/board/members_en"
              rel="noreferrer noopener"
              target="_blank"
            >
              https://edpb.europa.eu/about-edpb/board/members_en
            </a>
            . If you are in Switzerland, please visit this FDPIC site for contact details:&nbsp;
            <a
              href="https://www.edoeb.admin.ch/edoeb/en/home/the-fdpic/contact.html"
              rel="noreferrer noopener"
              target="_blank"
            >
              https://www.edoeb.admin.ch/edoeb/en/home/the-fdpic/contact.html
            </a>
            . If you are in the United Kingdom, please see this site for contact details:&nbsp;
            <a
              href="https://ico.org.uk/global/contact-us/"
              rel="noreferrer noopener"
              target="_blank"
            >
              https://ico.org.uk/global/contact-us/
            </a>
            .
          </p>
        </li>
      </ul>

      <p>
        If you would like to exercise any of these rights and can&#39;t do so directly via the
        Services or your device, you may contact us as indicated below.
      </p>

      <p>​</p>

      <p>​</p>

      <h3>Contact Us</h3>

      <p>
        If you have any questions about this Privacy Policy, please contact us at:&nbsp;
        <a href="mailto:namaste@aumhum.com">namaste@aumhum.com</a>
      </p>

      <p>If you are in India, you may also contact our representative at:</p>

      <ul>
        <li>
          <p>
            #206, Featherlite Evoma, Kadubheeshanahalli, Outer Ring Road, Marathalli, Bangalore
            560037&nbsp;
          </p>
        </li>
      </ul>

      <p>​</p>

      <p>​</p>

      <p>​</p>

      <p>​</p>

      <p>​</p>

      <p>​</p>
    </div>
  )
}
